import { Component, ChangeDetectionStrategy, output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { PageHeaderComponent } from '../../../components/page-header/page-header.component';

interface CategoryInfo {
  name: string;
  code: string;
  ageRange: string;
}

@Component({
  selector: 'app-admin-categories',
  standalone: true,
  imports: [CommonModule, TranslatePipe, PageHeaderComponent],
  templateUrl: './admin-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminCategoriesComponent {

  categories: CategoryInfo[] = [
    { name: 'BENJAMIN(E)', code: 'B', ageRange: '11-12' },
    { name: 'MINIME', code: 'M', ageRange: '13-14' },
    { name: 'CADET(TE)', code: 'C', ageRange: '15-16' },
    { name: 'JUNIOR', code: 'J', ageRange: '17-18' },
    { name: 'ESPOIR', code: 'E', ageRange: '19-22' },
    { name: 'SENIOR', code: 'S', ageRange: '23-39' },
    { name: 'VÉTÉRAN 1', code: 'V1', ageRange: '40-49' },
    { name: 'VÉTÉRAN 2', code: 'V2', ageRange: '50-59' },
    { name: 'VÉTÉRAN 3', code: 'V3', ageRange: '60+' },
  ];
}
